import axiosInstance from './axiosConfig';

export type TreatmentPlanStatus = 'draft' | 'active' | 'stopped';

export type PatientTreatmentPlanDto = {
  id: string;
  patientId: string;
  treatmentId: string;
  status: TreatmentPlanStatus;
  startDate: string | null;
  endDate: string | null;
};

export type ApiResult<T> = { result: T };

export type ListPatientTreatmentPlansResult = {
  plans: PatientTreatmentPlanDto[];
  activePlans: string[];
  availablePlans: string[];
  pastPlans: string[];
  attemptId?: string;
};

export const fetchPatientTreatmentPlans = (patientId: string) =>
  axiosInstance.get<ApiResult<ListPatientTreatmentPlansResult>>(
    `/patients/${patientId}/treatment-plans`
  );
